// ** MUI Import
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@1kit/ui/theme'
import { Logo as BaseLogo } from '@1kit/ui/components/Logo'

const Logo = styled(BaseLogo)`
  width: 80px;
  height: 80px;
`

function Spinner() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Logo small />
      <CircularProgress disableShrink sx={{ mt: 6 }} />
    </Box>
  )
}

export default Spinner
